import { AbilitiesManager } from './abilities-manager.ts';

let abilitiesManagerSingleton: AbilitiesManager;

export const getAbilitiesManager = () => {
  if (!abilitiesManagerSingleton) {
    abilitiesManagerSingleton = new AbilitiesManager();
  }

  return abilitiesManagerSingleton;
};
